import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  return getRequest(
    `serviceRequest/get-list/${parseInt(size, 10) || 10}/${parseInt(index, 10) || 0}/${searchTerm || '%20'}/${orderBy ||
      '%20'}`,
  )
}

export async function find(id) {
  return getRequest(`serviceRequest/edit/${id}`)
}

export async function save(values) {
  return postRequest(`serviceRequest/save`, values)
}

export function remove(values) {
  return postRequest(`serviceRequest/delete`, values)
}
